"use client"

import type React from "react"

import { useTranslation } from "react-i18next"
import { Button } from "@/components/ui/button"
import { ResourceModalTemplate } from "@/components/templates/ResourceModalTemplate/ResourceModalTemplate"
import { TermsContent } from "@/components/organisms/TermsContent/TermsContent"
import { PrivacyContent } from "@/components/organisms/PrivacyContent/PrivacyContent"
import { LegalInfoContent } from "@/components/organisms/LegalInfoContent/LegalInfoContent"
import { CookiesContent } from "@/components/organisms/CookiesContent/CookiesContent"

type ModalType = "terms" | "privacy" | "legal" | "cookies"

interface ResourceModalProps {
  type: ModalType
  trigger?: React.ReactNode
  className?: string
}

export function ResourceModal({ type, trigger, className }: ResourceModalProps) {
  const { t } = useTranslation()

  const getContent = () => {
    switch (type) {
      case "terms":
        return <TermsContent />
      case "privacy":
        return <PrivacyContent />
      case "legal":
        return <LegalInfoContent />
      case "cookies":
        return <CookiesContent />
      default:
        return <div>Content not found</div>
    }
  }

  const getTitle = () => {
    switch (type) {
      case "terms":
        return t("terms.title")
      case "privacy":
        return t("privacy.title")
      case "legal":
        return t("legal.title")
      case "cookies":
        return t("cookies.title")
      default:
        return "Legal Document"
    }
  }

  const getDate = () => {
    switch (type) {
      case "terms":
        return t("terms.date")
      case "privacy":
        return t("privacy.date")
      case "legal":
        return t("legal.date")
      case "cookies":
        return t("cookies.date")
      default:
        return ""
    }
  }

  const defaultTrigger = (
    <Button variant="link" className={`p-0 h-auto font-normal text-slate-600 hover:text-slate-900 ${className}`}>
      {getTitle()}
    </Button>
  )

  return (
    <ResourceModalTemplate title={getTitle()} date={getDate()} trigger={trigger || defaultTrigger}>
      {getContent()}
    </ResourceModalTemplate>
  )
}
